export default [{"tag":"path","att":{"d":"M3 4.0002v2L21 6V4L3 4.0002zm0 9.0002v-2l18-.0002v2l-18 .0002zm0 7.0001v-2l18-.0001v2l-18 .0001z"}}]